import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { redirectToAdminUrl } from '../config/adminHost';
import { ADMIN_PATHS } from '../constants/adminPaths';

const MainHostAdminRedirect = ({ path = ADMIN_PATHS.SUPPORT_LOGIN }) => {
  const location = useLocation();

  useEffect(() => {
    redirectToAdminUrl(path, location.search, location.hash);
  }, [path, location.search, location.hash]);

  return null;
};

export default MainHostAdminRedirect;
